import React from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import About from "../components/Sections/About";

function AboutUs() {
  return (
    <div>
      <Navbar />
      <About />
      <Footer />
    </div>
  );
}

export default AboutUs;
